<template>
  <button
    class="w-10 h-10 flex justify-center items-center focus:outline-hidden rounded-full text-gray-400 hover:text-gray-500 focus:text-gray-500"
  >
    <XMarkIcon class="w-6 h-6" />
  </button>
</template>

<script setup>
import { XMarkIcon } from "@heroicons/vue/20/solid"
</script>
